import { render, staticRenderFns } from "./note.vue?vue&type=template&id=c2ae87c8&scoped=true&"
import script from "./note.vue?vue&type=script&lang=js&"
export * from "./note.vue?vue&type=script&lang=js&"
import style0 from "./note.vue?vue&type=style&index=0&id=c2ae87c8&prod&lang=scss&scoped=true&"
import style1 from "./note.vue?vue&type=style&index=1&id=c2ae87c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae87c8",
  null
  
)

export default component.exports